<div id="video-container">
  <span id="counter">{{ counter }}</span>
  <video
    #localMediaContainer
    class="local-media-container"
  ></video>
</div>

